// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Yfkd","boxTitle":"Qualiphy_boxTitle__12W3z","box":"Qualiphy_box__1BNPC","toggleWrap":"Qualiphy_toggleWrap__bM62F"};